<template>
  <v-dialog
    v-model="isActive"
    v-bind="{
      scrollable: true,
      retainFocus: false,
      ...$attrs
    }"
    :width="$display.smAndDown.value ? '100%' : '456'"
    :fullscreen="$display.smAndDown.value && fullscreenMobile"
    :transition="$display.smAndDown.value ? 'dialog-bottom-transition' : undefined"
  >
    <template #activator="scope">
      <slot
        name="activator"
        v-bind="scope"
      />
    </template>

    <v-card
      class="d-flex flex-column overflow-auto ui-kit-bg-gray-0"
      :rounded="$display.mdAndUp.value ? 'sm' : undefined"
    >
      <div
        v-if="!hideCloseBtn"
        class="flex-grow-0"
      >
        <AppToolbar
          :title="title"
          :borderless="borderlessTitle || Boolean($slots['title-append'])"
          :close-to="!backTo && !hideCloseBtn"
          :back-to="backTo && !hideCloseBtn"
          @click:close="handleClickClose"
          @click:back="handleClickClose"
        />
        <slot name="title-append" />
        <v-divider
          v-if="!borderlessTitle && $slots['title-append']"
          class="mt-2"
        />
      </div>

      <v-sheet
        class="flex-grow-1"
        :class="{
          'overflow-y-auto': fixedToolbar && !persistentScroll,
          'overflow-y-scroll': persistentScroll
        }"
      >
        <v-sheet
          height="100%"
          class="limit-container d-flex flex-column"
        >
          <slot />
        </v-sheet>
      </v-sheet>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { useDisplay } from 'vuetify'

defineProps({
  backTo: { type: Boolean, default: false },
  hideCloseBtn: { type: Boolean, default: false },
  title: { type: String, default: '' },
  borderlessTitle: { type: Boolean, default: false },
  fixedToolbar: { type: Boolean, default: false },
  persistentScroll: { type: Boolean, default: false },
  fullscreenMobile: { type: Boolean, default: true },
})

const emit = defineEmits(['click:prepend-icon'])

defineOptions({
  inheritAttrs: false,
})

const isActive = defineModel<boolean>()
const $display = useDisplay()

function handleClickClose() {
  emit('click:prepend-icon')
  isActive.value = false
}
</script>
